// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Other/UCP/UCP.css */

.ucp-popup-actions {
  position: fixed;
  bottom: 20px;
  left: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 9999;
}

.ucp-popup-btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 50px;
  cursor: pointer;
  font-size: 14px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.ucp-popup-btn-demo {
  background-color: #007bff;
}

.ucp-popup-btn-in {
  background-color: #16a34a;
}

.ucp-popup-btn-med {
  background-color: #dc2626;
}

.ucp-popup-btn-ocube {
  background-color: #7c3aed;
}

.ucp-popup-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 8px rgba(0, 45, 93, 0.3);
}

.ucp-popup-btn-demo:hover {
  background-color: #0069d9;
}

.ucp-popup-btn-in:hover {
  background-color: #15803d;
}

.ucp-popup-btn-med:hover {
  background-color: #b91c1c;
}

.ucp-popup-btn-ocube:hover {
  background-color: #6d28d9;
}

.ucp-popup-container {
  position: fixed;
  width: min(420px, calc(100vw - 24px));
  height: min(720px, calc(100vh - 88px));
  min-height: min(520px, calc(100vh - 88px));
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  z-index: 10000;
  will-change: transform;
  transition: opacity 0.3s ease;
  opacity: 1;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid rgba(15, 23, 42, 0.12);
}

.ucp-popup-container.ucp-hidden {
  display: none;
}

.ucp-popup-header {
  position: relative;
  width: 100%;
  height: 34px;
  min-height: 34px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 8px;
  cursor: move;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  -webkit-user-select: none;
          user-select: none;
  top: auto;
  box-sizing: border-box;
}

.ucp-minimize-btn {
  background-color: #EF6F53;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  padding: 0;
  transition: all 0.2s ease;
  margin: 3px;
}

.ucp-minimize-btn:hover {
  background-color: #ff4757;
  transform: scale(1.1);
}

.ucp-iframe {
  width: 100%;
  height: calc(100% - 34px);
  border: none;
  margin: 0;
  background: white;
  display: block;
}

.ucp-hidden {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
}

.ucp-iframe::-webkit-scrollbar {
  width: 10px;
}

.ucp-iframe::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.ucp-iframe::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.ucp-iframe::-webkit-scrollbar-thumb:hover {
  background: #555;
}

@media (max-width: 520px) {
  .ucp-popup-actions {
    left: 12px;
    bottom: 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .ucp-popup-container {
    width: calc(100vw - 16px);
    height: calc(100vh - 72px);
    min-height: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Other/UCP/UCP.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,sCAAsC;EACtC,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,6BAA6B;EAC7B,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAiB;UAAjB,iBAAiB;EACjB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,aAAa;EACf;AACF","sourcesContent":["/* src/components/routes/Other/UCP/UCP.css */\n\n.ucp-popup-actions {\n  position: fixed;\n  bottom: 20px;\n  left: 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  z-index: 9999;\n}\n\n.ucp-popup-btn {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 50px;\n  cursor: pointer;\n  font-size: 14px;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);\n  transition: all 0.3s ease;\n}\n\n.ucp-popup-btn-demo {\n  background-color: #007bff;\n}\n\n.ucp-popup-btn-in {\n  background-color: #16a34a;\n}\n\n.ucp-popup-btn-med {\n  background-color: #dc2626;\n}\n\n.ucp-popup-btn-ocube {\n  background-color: #7c3aed;\n}\n\n.ucp-popup-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 8px rgba(0, 45, 93, 0.3);\n}\n\n.ucp-popup-btn-demo:hover {\n  background-color: #0069d9;\n}\n\n.ucp-popup-btn-in:hover {\n  background-color: #15803d;\n}\n\n.ucp-popup-btn-med:hover {\n  background-color: #b91c1c;\n}\n\n.ucp-popup-btn-ocube:hover {\n  background-color: #6d28d9;\n}\n\n.ucp-popup-container {\n  position: fixed;\n  width: min(420px, calc(100vw - 24px));\n  height: min(720px, calc(100vh - 88px));\n  min-height: min(520px, calc(100vh - 88px));\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  z-index: 10000;\n  will-change: transform;\n  transition: opacity 0.3s ease;\n  opacity: 1;\n  user-select: none;\n  border: 1px solid rgba(15, 23, 42, 0.12);\n}\n\n.ucp-popup-container.ucp-hidden {\n  display: none;\n}\n\n.ucp-popup-header {\n  position: relative;\n  width: 100%;\n  height: 34px;\n  min-height: 34px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0 8px;\n  cursor: move;\n  background-color: #f5f5f5;\n  border-bottom: 1px solid #ddd;\n  user-select: none;\n  top: auto;\n  box-sizing: border-box;\n}\n\n.ucp-minimize-btn {\n  background-color: #EF6F53;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  padding: 0;\n  transition: all 0.2s ease;\n  margin: 3px;\n}\n\n.ucp-minimize-btn:hover {\n  background-color: #ff4757;\n  transform: scale(1.1);\n}\n\n.ucp-iframe {\n  width: 100%;\n  height: calc(100% - 34px);\n  border: none;\n  margin: 0;\n  background: white;\n  display: block;\n}\n\n.ucp-hidden {\n  visibility: hidden;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.ucp-iframe::-webkit-scrollbar {\n  width: 10px;\n}\n\n.ucp-iframe::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.ucp-iframe::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.ucp-iframe::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n@media (max-width: 520px) {\n  .ucp-popup-actions {\n    left: 12px;\n    bottom: 12px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .ucp-popup-container {\n    width: calc(100vw - 16px);\n    height: calc(100vh - 72px);\n    min-height: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
